import { memoize } from 'lodash';
import React from 'react';
import { StatusFieldOption } from 'api/tasks';
import { EmptyCell } from 'components/atoms/empty-cell';
import { ProjectStatus } from '../components/organisms/projects/project-list/columns/project-status';

export const renderStatusField = memoize(
  (statusValue: number, status: StatusFieldOption) => {
    if (statusValue) {
      return <ProjectStatus status={status} />;
    }

    return <EmptyCell />;
  },
);
